import React from "react";
import { Switch, Route } from "react-router-dom";
import SettingsMenu from "./SettingsMenu";
import AccountSettings from "./AccountSettings";
import FullPageSpinner from "../../FullPageSpinner";
import _ from "lodash";
import { connect } from "react-redux";
import PasswordSettings from "./PasswordSettings";
import PrivacySettings from "./PrivacySettings";
import SocialMedia from "./SocialMedia";
import { connectTwitterAccount } from "../../../api/twitter";
import { isMobile } from "react-device-detect";
import { Helmet } from "react-helmet";
import "./styles.scss";

class Settings extends React.Component {
  connectWithTwitterParams = async (searchParams) => {
    try {
      let oauth_token = searchParams.get("oauth_token");
      let oauth_verifier = searchParams.get("oauth_verifier");
      await connectTwitterAccount({
        oauth_token,
        oauth_verifier,
      });
      /*
      if (isMobile) {
        window.location.href = "hudl://";
      } else {
        window.location.href = "/";
      }
        */
    } catch (error) {
      console.log(error);
    }
  };
  componentDidMount() {
    let searchParams = new URLSearchParams(window.location.search);
    if (searchParams.has("oauth_token") && searchParams.has("oauth_verifier") && _.isNull(this.props.current_user)) {
      this.connectWithTwitterParams(searchParams);
    }
  }

  getMetaContent() {
    const { username, address: { country, city, state } = {} } = this.props.current_user;
    if (country === "United States of America") {
      return `Connect with ${username} (${city}, ${state}) on UNIFI Music`;
    } else {
      return `Connect with ${username} (${country}) on UNIFI Music`;
    }
  }

  render() {
    const { current_user: { username } = {} } = this.props;
    return !username ? (
      <FullPageSpinner />
    ) : (
      <div id="settings" className="container m-4 mx-auto pl-sm-0 pr-sm-0">
        <Helmet>
          <title>{username} on UNIFI Music</title>
          <meta name="description" content={this.getMetaContent()} />
        </Helmet>
        <div className="row no-gutters">
          <div className="col-md-25 col-sm-100 px-md-4 setting-menu">
            <SettingsMenu user={this.props.current_user} />
          </div>
          <div className="col-md-75 col-sm-100 mt-sm-4 px-md-4">
            <Switch>
              <Route path="/settings" exact render={(props) => <AccountSettings {...props} user={this.props.current_user} />} />
              <Route path="/settings/social-media" exact render={(props) => <SocialMedia {...props} user={this.props.current_user} />} />
              <Route path="/settings/change-password" exact render={(props) => <PasswordSettings {...props} user={this.props.current_user} />} />
              <Route path="/settings/privacy" exact render={(props) => <PrivacySettings {...props} user={this.props.current_user} />} />
              <Route path="/settings/contacts" exact render={null} />
            </Switch>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { current_user } = state;
  return { current_user };
}
export default connect(mapStateToProps)(Settings);
